var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.04,27.29c-0.61,2.71-1.11,4.91-1.67,7.38c2.12,0,4-0.03,5.88,0.01c2.99,0.05,4.89,1.61,4.96,4.45 c0.13,5.2,0.1,10.41,0.01,15.62c-0.04,2.07-1.58,3.38-3.46,3.29c-1.81-0.08-3.08-1.35-3.12-3.37c-0.07-3.68-0.09-7.36,0-11.04 c0.05-1.92-0.55-2.8-2.76-2.68c-2.92,0.16-5.85,0.06-8.78,0.03c-3.77-0.03-5.73-2.15-5.05-5.63c0.75-3.88,1.6-7.74,2.55-11.58 c0.8-3.24,3.17-4.57,6.54-3.77c1.97,0.47,4.05,0.83,5.82,1.71c3.3,1.63,6.52,2.87,10.39,2.28c2.09-0.32,3.63,1.08,3.68,2.7 c0.05,1.56-1.22,2.76-3.34,2.92C33.74,29.93,29.77,30.2,26.04,27.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.49,48.04c-2.81,0-5.29,0.05-7.76-0.01c-5.07-0.11-8.59-2.95-9.49-7.6c-1.02-5.3-2.02-10.61-3.03-15.92 c-0.05-0.27-0.06-0.55-0.1-0.83c-0.18-1.38,0.08-2.59,1.8-2.78c1.64-0.18,2.29,0.82,2.56,2.23c0.99,5.38,2.05,10.75,3.05,16.13 c0.59,3.18,2.25,4.55,5.66,4.58c2.78,0.02,5.56-0.02,8.33,0.02c2.26,0.03,3.21,0.9,3.24,3.03c0.05,2.91,0.01,5.82,0.02,8.73 c0,1.33-0.42,2.39-2.01,2.45c-1.73,0.06-2.24-1.09-2.27-2.47C21.46,53.18,21.49,50.76,21.49,48.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.02,36.39c-2.58,0-4.98-0.03-7.38,0.01c-1.58,0.02-2.93-0.46-2.96-2.06c-0.03-1.61,1.29-2.13,2.88-2.12 c6.51,0.02,13.01,0.02,19.52,0c1.6,0,2.88,0.55,2.84,2.16c-0.04,1.47-1.27,2.03-2.78,2.02c-2.47-0.03-4.93-0.01-7.64-0.01 c0,4.75,0,9.31,0,13.86c0,1.8,0.01,3.6-0.01,5.41c-0.01,1.33-0.53,2.36-2.1,2.41c-1.7,0.04-2.27-1.02-2.28-2.45 c-0.01-5.96-0.01-11.92-0.01-17.89C48.1,37.39,48.06,37.05,48.02,36.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.85,12.11c0-3.49,2.86-6.2,6.53-6.18c3.6,0.02,6.63,2.87,6.59,6.21c-0.04,3.3-3.2,6.28-6.65,6.26 C19.69,18.37,16.85,15.61,16.85,12.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmissions);
export default __webpack_public_path__ + "static/media/admissions.486f75bb6a1be3c2d68cd55c5efb0171.svg";
export { ForwardRef as ReactComponent };